import {useTranslations} from 'src/components/TranslationsContext';
import {isRetryableH5Error} from 'src/lib/api/h5';

// A failed H5 read's note, with a retry for the failures a retry can clear.
export default function RequestFailed({
  message,
  error,
  onRetry,
}: {
  message: string;
  error: unknown;
  onRetry: () => unknown;
}) {
  const {t} = useTranslations();
  return (
    <>
      {message}{' '}
      {isRetryableH5Error(error) && (
        <button type="button" className="text-blue-600 underline" onClick={() => onRetry()}>
          {t('retry')}
        </button>
      )}
    </>
  );
}
